<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
button {
	border-color: transparent;
}
button:focus {
	outline: none;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: 0.3s;
}
.progress-bar {
	background-color: #616e84;
}
</style>
